import { draftel_codecs_pack_terkk$klimakomora } from "./ter-draftel-codec-lib-terkk-klimakomora";
import { draftel_codecs_pack_terkk$modul } from "./ter-draftel-codec-lib-terkk-modul";
import { draftel_codecs_pack_terkk$materijalcustom } from "./ter-draftel-codec-lib-terkk-materijalcustom";
import { draftel_codecs_pack_terkk$_bundle_panel } from "./ter-draftel-codec-lib-terkk-bundle-panel";
import { draftel_codecs_pack_terkk$demper } from "./ter-draftel-codec-lib-terkk-demper";
import { draftel_codecs_pack_terkk$elasticnaveza } from "./ter-draftel-codec-lib-terkk-elasticnaveza";
import { draftel_codecs_pack_terkk$_bundle_eliminatorkapi } from "./ter-draftel-codec-lib-terkk-bundle-eliminatorkapi";
import { draftel_codecs_pack_terkk$spoljnafiksnazaluzina } from "./ter-draftel-codec-lib-terkk-spoljnafiksnazaluzina";
import { draftel_codecs_pack_terkk$kadica, draftel_codecs_pack_terkk$kadica_v2 } from "./ter-draftel-codec-lib-terkk-kadica";
import { draftel_codecs_pack_terkk$_bundle_postolje } from "./ter-draftel-codec-lib-terkk-bundle-postolje";
import { virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { draftel_codecs_pack_terkk$_bundle_ppv } from "./ter-draftel-codec-lib-terkk-bundle-ppv";
import { terUtilsSortirajDrafteleKonzistentnimRedosledom } from "./ter-redosled-utils";
import { _smartbom_manipulator_add_draftel, _smartbom_manipulator_init_make_smartbom } from "../utils/frfr-smartbom-utils";
import { draftel_codecs_pack_terkk$_bundle_profilcustom } from "./ter-draftel-codec-lib-terkk-bundle-profilcustom";
import { draftel_codecs_pack_terkk$_bundle_limcustom } from "./ter-draftel-codec-lib-terkk-bundle-limcustom";
import { draftel_codecs_pack_terkk$_bundle_krov } from "./ter-draftel-codec-lib-terkk-bundle-krov";
import { draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca } from "./ter-draftel-codec-lib-terkk-bundle-kucisteelektrogrejaca";
import { draftel_codecs_pack_terkk$_bundle_ppd } from "./ter-draftel-codec-lib-terkk-bundle-ppd";
import { draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje } from "./ter-draftel-codec-lib-terkk-bundle-ramfilteranauklizavanje";
import { draftel_codecs_pack_terkk$_bundle_klizac } from "./ter-draftel-codec-lib-terkk-bundle-klizac";
import { draftel_codecs_pack_terkk$_bundle_paletapakovanja } from "./ter-draftel-codec-lib-terkk-bundle-paletapakovanja";
import { draftel_codecs_pack_terkk$_bundle_usmerivacvazduha } from "./ter-draftel-codec-lib-terkk-bundle-usmerivacvazduha";
import { draftel_codecs_pack_terkk$_bundle_rammraztermostata } from "./ter-draftel-codec-lib-terkk-bundle-rammraztermostata";
import { draftel_codecs_pack_terkk$_bundle_ramfiltera } from "./ter-draftel-codec-lib-terkk-bundle-ramfiltera";
import { draftel_codecs_pack_terkk$_bundle_protivkisnazaluzina } from "./ter-draftel-codec-lib-terkk-bundle-protivkisnazaluzina";
import { draftel_codecs_pack_terkk$_bundle_prigusivacbuke } from "./ter-draftel-codec-lib-terkk-bundle-prigusivacbuke";
import { draftel_codecs_pack_terkk$_bundle_parniovlazivac } from "./ter-draftel-codec-lib-terkk-bundle-parniovlazivac";
import { draftel_codecs_pack_terkk$_bundle_nosacventilatora } from "./ter-draftel-codec-lib-terkk-bundle-nosacventilatora";
import { draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata } from "./ter-draftel-codec-lib-terkk-bundle-klizacramamraztermostata";
import { draftel_codecs_pack_terkk$_bundle_npr } from "./ter-draftel-codec-lib-terkk-bundle-npr";
import { draftel_codecs_pack_terkk$_bundle_nrr } from "./ter-draftel-codec-lib-terkk-bundle-nrr";
/*
import { draftel_codecs_pack_zzkitc$kitc } from "../utils/zz/zz-draftel-codec-lib-zzkitc-kitc";
import { draftel_codecs_pack_zzkitc$kitc$element } from "../utils/zz/zz-draftel-codec-lib-zzkitc-kitc-element";
import { draftel_codecs_pack_zzkitc$kitc$wbp } from "../utils/zz/zz-draftel-codec-lib-zzkitc-wbp";
*/
import { draftel_codecs_pack_terkk$_special_protobomp } from "./ter-draftel-codec-lib-terkk-special-protobomp";
import { terUtils_make_smartbom_blank_latest, terUtils_make_smartbom_manifest_terkk_v1_0 } from "./ter-smartbom-utils";
import { _getTerkkCparamsDefaultFromLib } from "./ter-params-utils";
import { draftel_codecs_pack_expt$sketch } from "./ter-draftel-codec-lib-expt-special-sketch";
import { _derivat_terkk_kadica_v2_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-kadica";
import { _derivat_terkk_klizac_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-klizac";
import { _derivat_terkk_kelg_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-kucisteelektrogrejaca";
import { _derivat_terkk_npr_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-npr";
import { _derivat_terkk_ppvnosacv_izracunaj_za_step_protobomp, _derivat_terkk_ppv_izracunaj_za_subform_arr } from "./ter-derivat-lib-terkk-ppv";
import { _derivat_terkk_parniovlazivac_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-parniovlazivac";
import { _derivat_terkk_ppd_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-ppd";
import { _derivat_terkk_prigusivacbuke_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-prigusivacbuke";
import { _derivat_terkk_pkz_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-protivkisnazaluzina";
import { _derivat_terkk_ramfilteranauklizavanje_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-ramfilteranauklizavanje";
import { _derivat_terkk_rammraztermostata_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-rammraztermostata";
import { _derivat_terkk_usmerivacvazduha_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-usmerivacvazduha";
import { _derivat_terkk_paletapakovanja_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-paletapakovanja";
import { _derivat_terkk_nrr_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-nrr";
import { _derivat_terkk_postolje_izracunaj_za_subform_arr } from "./ter-derivat-lib-terkk-postolje";
import { _derivat_terkk_eliminatorkapi_izracunaj_za_subform_arr } from "./ter-derivat-lib-terkk-eliminatorkapi";
import { _derivat_terkk_ramfiltera_izracunaj_za_step_protobomp } from "./ter-derivat-lib-terkk-ramfiltera";


// TER DRAFTEL CODECS LIB


/*
PROBLEMATIKA:

-- Posebni fajlovi za rad sa svakim draftelom...

- definicja draftela
- defincija forme
- form state preset IAKO je forma dinamicaka u presetu moraj ubiti pokrivena sva polja...
- prepare for submit



- u okviru presrta mora biti null-ovanej svih polja...
KAKO se vrsi nullovanje?
da li se za formu moze koristi null kao u bazi ili 


kod prikaza svih definicija treba napraviti i WODGEZT ZA PRIKAZ DUPLIKATA POLJA da bihznao koliiko polja treba u bazi...
export u JSON svih polja za sve virtele...

*/


//
export const _draftel_codecs_multiadapter = () => {
  const multiadapter_lib = {};
  const SMARTEL_TITLE = "smartel_title";
  const GET_DEFAULT_PRESET_STATE = "get_default_preset_state";
  const DATARENDER_VIRBOM_FROM_DRAFTEL = "datarender_virbom_from_single_draftel";
  const VIRTELSCHEMAKEY_FOR_PODS_INPUT = "virtelschemakey_for_pods_input";
  const FORM_FUNCTIONS = "form_functions";
  const CALCULATE_FOR_STEP_SUBFORM = "izracunaj_za_step_subform";
  const CALCULATE_FOR_STEP_PROTOBOMP = "izracunaj_za_step_protobomp";
  //
  // ---- LIB
  //
  multiadapter_lib["terkk$klimakomora"] = {
    [SMARTEL_TITLE]: "Klima komora",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: null,
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$klimakomora.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$klimakomora.drafel_to_virbom(draftel);
      return virbom;
    },

  };
  //
  multiadapter_lib["terkk$modul"] = {
    [SMARTEL_TITLE]: "Modul",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$modul",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$modul.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$modul.drafel_to_virbom(draftel);
      return virbom;
    },

  };
  //
  // Delovi modula
  //
  multiadapter_lib["terkk$modul$rogalj"] = null; // NE POJAVLJUJE SE KAO SMARTEL
  //
  multiadapter_lib["modul$profilosnovni"] = null; // NE POJAVLJUJE SE KAO SMARTEL
  //
  multiadapter_lib["terkk$modul$profilpregradni"] = null; // NE POJAVLJUJE SE KAO SMARTEL
  //
  multiadapter_lib["terkk$_bundle_panel"] = {
    [SMARTEL_TITLE]: "Panel (PAN)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$panel",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_panel.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_bundle_panel.bundleDrafel_to_virbom(draftel);
      return virbom;
    },

  };
  //
  multiadapter_lib["terkk$panel"] = null; // OVO NIJE BUNDLE // NE POJAVLJUJE SE KAO SMARTEL
  //
  multiadapter_lib["terkk$demper"] = {
    [SMARTEL_TITLE]: "Demper (DEM)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: null,
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$demper.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$demper.drafel_to_virbom(draftel);
      return virbom;
    },

  };
  //
  multiadapter_lib["terkk$elasticnaveza"] = {
    [SMARTEL_TITLE]: "Elastična veza (ELV)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: null,
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$elasticnaveza.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$elasticnaveza.drafel_to_virbom(draftel);
      return virbom;
    },

  };
  //
  multiadapter_lib["terkk$_bundle_eliminatorkapi"] = {
    [SMARTEL_TITLE]: "Eliminator kapi (ELK)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$eliminatorkapi",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_bundle_eliminatorkapi.bundleDrafel_to_virbom(draftel);
      return virbom;
    },
    // _derivat_terkk_eliminatorkapi_izracunaj_za_subform_arr
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_SUBFORM]: _derivat_terkk_eliminatorkapi_izracunaj_za_subform_arr,
    },

  };
  //
  multiadapter_lib["terkk$eliminatorkapi"] = null; // OVO NIJE BUNDLE // NE POJAVLJUJE SE KAO SMARTEL
  //
  //
  multiadapter_lib["terkk$spoljnafiksnazaluzina"] = {
    [SMARTEL_TITLE]: "Spoljna fiksna žaluzina (SPF)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: null,
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$spoljnafiksnazaluzina.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$spoljnafiksnazaluzina.drafel_to_virbom(draftel);
      return virbom;
    },

  };
  //
  // Abecedni deo redosleda Ispod SFZ a iznad postolja
  //
  multiadapter_lib["terkk$kadica"] = {
    [SMARTEL_TITLE]: "Kadica v1",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$kadica",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$kadica.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$kadica.drafel_to_virbom(draftel);
      return virbom;
    },
  };
  //
  multiadapter_lib["terkk$kadica_v2"] = {
    [SMARTEL_TITLE]: "Kadica v2 (KAD)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$kadica", // TODO
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$kadica_v2.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_kadica_v2_izracunaj_za_step_protobomp,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_klizac"] = {
    [SMARTEL_TITLE]: "Klizač (KLI)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$klizac",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_klizac.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_klizac_izracunaj_za_step_protobomp,
    },

  };
  //
  // ???
  //
  multiadapter_lib["terkk$_bundle_klizacramamraztermostata"] = {
    [SMARTEL_TITLE]: "Klizač Rama Mraz Termostata",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$klizacramamraztermostata",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.default_preset_state();
    },
    // TODO
    // OBSOLETE
    // PPGRUPA RMT - VAZNO NE KORISTI SE OVAJ klizacramamraztermostata jer je on sada u sastavu PPGRUPA RMT

  };
  //
  multiadapter_lib["terkk$_bundle_kucisteelektrogrejaca"] = {
    [SMARTEL_TITLE]: "Kućište elektro grejača (KEG)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$kucisteelektrogrejaca",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_kelg_izracunaj_za_step_protobomp,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_npr"] = {
    [SMARTEL_TITLE]: "Nosač pločastog rekuperatora (NPR)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$npr", // TODO
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_npr.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_npr_izracunaj_za_step_protobomp,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_nrr"] = {
    [SMARTEL_TITLE]: "Nosač rotacionog rekuperatora (NRR)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$nrr", // TODO
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_nrr.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_nrr_izracunaj_za_step_protobomp,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_nosacventilatora"] = {
    [SMARTEL_TITLE]: "Nosač ventilatora",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$nosacventilatora",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_nosacventilatora.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_ppvnosacv_izracunaj_za_step_protobomp,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_parniovlazivac"] = {
    [SMARTEL_TITLE]: "Parni ovlaživač (POV)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$parniovlazivac",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_parniovlazivac.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_parniovlazivac_izracunaj_za_step_protobomp,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_ppd"] = {
    [SMARTEL_TITLE]: "PPD",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$ppd",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_ppd.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_ppd_izracunaj_za_step_protobomp,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_ppv"] = {
    [SMARTEL_TITLE]: "PPV",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$ppv",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_ppv.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_bundle_ppv.bundleDrafel_to_virbom(draftel);
      return virbom;
    },
    // _derivat_terkk_ppv_izracunaj_za_subform_arr
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_SUBFORM]: _derivat_terkk_ppv_izracunaj_za_subform_arr,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_prigusivacbuke"] = {
    [SMARTEL_TITLE]: "Prigušivač buke (PRB)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$prigusivacbuke",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_prigusivacbuke.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      // const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp_subpp_prbkulisa, draftel._protobomp_subpp_prbnosac]);
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_prigusivacbuke_izracunaj_za_step_protobomp,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_protivkisnazaluzina"] = {
    [SMARTEL_TITLE]: "Protiv Kišna Žaluzina (PKZ)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$protivkisnazaluzina", // TODO
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_protivkisnazaluzina.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_pkz_izracunaj_za_step_protobomp,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_ramfiltera"] = {
    [SMARTEL_TITLE]: "Ram filtera (RFI)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$ramfiltera",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_ramfiltera.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_ramfiltera_izracunaj_za_step_protobomp,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_ramfilteranauklizavanje"] = {
    [SMARTEL_TITLE]: "Ram filtera na uklizavanje",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$ramfilteranauklizavanje",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      // const virbom = draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.bundleDrafel_to_virbom(draftel);
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_ramfilteranauklizavanje_izracunaj_za_step_protobomp,
    },
    // TODO

  };
  //
  multiadapter_lib["terkk$_bundle_rammraztermostata"] = {
    [SMARTEL_TITLE]: "Ram mraz termostata (RMT)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$rammraztermostata",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_rammraztermostata.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_rammraztermostata_izracunaj_za_step_protobomp,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_usmerivacvazduha"] = {
    [SMARTEL_TITLE]: "Usmerivač vazduha",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: null, // TODO
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_usmerivacvazduha.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_usmerivacvazduha_izracunaj_za_step_protobomp,
    },

  };
  //
  // Zadnji deo redosleda pocinje od postolja.
  //
  multiadapter_lib["terkk$_bundle_postolje"] = {
    [SMARTEL_TITLE]: "Postolje modula (POS)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$postolje",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_postolje.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_bundle_postolje.bundleDrafel_to_virbom(draftel);
      return virbom;
    },
    // _derivat_terkk_postolje_izracunaj_za_subform_arr
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_SUBFORM]: _derivat_terkk_postolje_izracunaj_za_subform_arr,
    },

  };
  //
  multiadapter_lib["terkk$_bundle_krov"] = {
    [SMARTEL_TITLE]: "Krov (KRV)",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$krov$child",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_krov.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_bundle_krov.bundleDrafel_to_virbom(draftel);
      return virbom;
    },

  };
  //
  multiadapter_lib["terkk$_bundle_paletapakovanja"] = {
    // [SMARTEL_TITLE]: "**** Paleta pakovanja (PAL)",
    [SMARTEL_TITLE]: "Paleta pakovanja (PAL)",
    // [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: null, // TODO
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$paletapakovanja", // TODO
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_paletapakovanja.default_preset_state();
    },
    // TODO PP2024JUL
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },
    [FORM_FUNCTIONS]: {
      [CALCULATE_FOR_STEP_PROTOBOMP]: _derivat_terkk_paletapakovanja_izracunaj_za_step_protobomp,
    },

  };
  //
  //
  multiadapter_lib["terkk$_bundle_limcustom"] = {
    [SMARTEL_TITLE]: "Lim CUSTOM",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: null,
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_limcustom.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_bundle_limcustom.bundleDrafel_to_virbom(draftel);
      return virbom;
    },

  };
  //
  multiadapter_lib["terkk$_bundle_profilcustom"] = {
    [SMARTEL_TITLE]: "Profil CUSTOM",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: null,
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$_bundle_profilcustom.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$_bundle_profilcustom.bundleDrafel_to_virbom(draftel);
      return virbom;
    },

  };
  //
  multiadapter_lib["terkk$materijalcustom"] = {
    [SMARTEL_TITLE]: "Materijal CUSTOM",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: null,
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_terkk$materijalcustom.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = draftel_codecs_pack_terkk$materijalcustom.drafel_to_virbom(draftel);
      return virbom;
    },

  };
  //
  // experimental
  //
  multiadapter_lib["expt$sketch"] = {
    [SMARTEL_TITLE]: "* SKICA",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: null,
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_expt$sketch.default_preset_state();
    },
    /*
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      const virbom = ; //
      return virbom;
    },
    */

  };
  //
  /*
  multiadapter_lib["zzkitc$kitc"] = {
    [SMARTEL_TITLE]: "K",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: null,
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_zzkitc$kitc.default_preset_state();
    },
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      // const virbom = draftel_codecs_pack_zzkitc$kitc.drafel_to_virbom(draftel); //
      const virbom = draftel_codecs_pack_zzkitc$kitc.bundleDrafel_to_virbom(draftel); //
      return virbom;
    },

  };
  */
  //
  /*
  multiadapter_lib["zzkitc$kitc$element"] = {
    [SMARTEL_TITLE]: "K.Element",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "zzkitc$kitc$element",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_zzkitc$kitc$element.default_preset_state();
    },
    // TODO
    [DATARENDER_VIRBOM_FROM_DRAFTEL]: (draftel) => {
      // const virbom = draftel_codecs_pack_zzkitc$kitc$element.bundleDrafel_to_virbom(draftel); //
      const virbom = draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom([draftel._protobomp]);
      return virbom;
    },

  };
  */
  //
  /*
  multiadapter_lib["zzkitc$kitc$wbp"] = {
    [SMARTEL_TITLE]: "K.?",
    [GET_DEFAULT_PRESET_STATE]: () => {
      return draftel_codecs_pack_zzkitc$kitc$wbp.default_preset_state();
    },
    // ???

  };
  */
  //
  //
  // FIX ZA NOVE
  multiadapter_lib["terkk$_bundle_novo"] = {
    [SMARTEL_TITLE]: "?NOVO?",
    [VIRTELSCHEMAKEY_FOR_PODS_INPUT]: "terkk$novo",
    [GET_DEFAULT_PRESET_STATE]: () => {
      // return draftel_codecs_pack_terkk$_bundle_novo.default_preset_state();
      return { _subform_arr: [] };
    },
    // nema datarender metod za _bundle_novo

  };
  //
  //
  // -----METHODS
  const _adapter_methods = {};
  //
  _adapter_methods.get_smartel_title = (_draftelschemakey) => {
    let _smartel_title = "?"; //
    if (multiadapter_lib[_draftelschemakey] && typeof multiadapter_lib[_draftelschemakey][SMARTEL_TITLE] === 'string') {
      _smartel_title = multiadapter_lib[_draftelschemakey][SMARTEL_TITLE];
    }
    return _smartel_title;
  };
  //
  _adapter_methods.get_default_draftel_preset_state = (_draftelschemakey) => {
    let _default_state = {};
    if (multiadapter_lib[_draftelschemakey] && typeof multiadapter_lib[_draftelschemakey][GET_DEFAULT_PRESET_STATE] === 'function') {
      _default_state = multiadapter_lib[_draftelschemakey][GET_DEFAULT_PRESET_STATE]();
    }
    return _default_state;
  };
  //
  _adapter_methods.get_schemakey_for_pods_input = (_draftelschemakey) => {
    let _schemakey_for_pods_input = "terkk$novo"; // FIX BUDZENJE // TODO
    if (multiadapter_lib[_draftelschemakey] && typeof multiadapter_lib[_draftelschemakey][VIRTELSCHEMAKEY_FOR_PODS_INPUT] === 'string') {
      _schemakey_for_pods_input = multiadapter_lib[_draftelschemakey][VIRTELSCHEMAKEY_FOR_PODS_INPUT];
    }
    return _schemakey_for_pods_input;
  };
  //
  _adapter_methods.datarender_virbom_from_single_draftel = (draftel) => {
    let virbom = null;
    const _draftelschemakey = draftel._draftelschemakey;
    if (multiadapter_lib[_draftelschemakey] && typeof multiadapter_lib[_draftelschemakey][DATARENDER_VIRBOM_FROM_DRAFTEL] === 'function') {
      virbom = multiadapter_lib[_draftelschemakey][DATARENDER_VIRBOM_FROM_DRAFTEL](draftel);
    }
    return virbom;
  };
  //
  // TODO NOVO
  _adapter_methods[FORM_FUNCTIONS] = (_draftelschemakey) => {
    if (multiadapter_lib[_draftelschemakey] && typeof multiadapter_lib[_draftelschemakey][FORM_FUNCTIONS]) {
      return multiadapter_lib[_draftelschemakey][FORM_FUNCTIONS];
    } else {
      // ERROR property not exist in multiadapter
      console.log('ERROR property ' + FORM_FUNCTIONS + ' not exist in _draftel_codecs_multiadapter for _draftelschemakey: ', _draftelschemakey);
      return false;
    }
  };
  //
  return _adapter_methods;
  // return false;
};



//
export const _draftel_codecs_datarender_virbom_from_single_draftel = (draftel) => {
  //
  return _draftel_codecs_multiadapter().datarender_virbom_from_single_draftel(draftel);
};


// OLD
const OLD_get_default_draftel_preset_state = (_draftelschemakey) => {
  if (_draftelschemakey === "terkk$klimakomora") {
    return draftel_codecs_pack_terkk$klimakomora.default_preset_state();
  }
  if (_draftelschemakey === "terkk$modul") {
    return draftel_codecs_pack_terkk$modul.default_preset_state();
  }
  //
  if (_draftelschemakey === "terkk$_bundle_panel") {
    return draftel_codecs_pack_terkk$_bundle_panel.default_preset_state();
  }
  if (_draftelschemakey === "terkk$demper") {
    return draftel_codecs_pack_terkk$demper.default_preset_state();
  }
  if (_draftelschemakey === "terkk$elasticnaveza") {
    return draftel_codecs_pack_terkk$elasticnaveza.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_eliminatorkapi") {
    return draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_preset_state();
  }
  if (_draftelschemakey === "terkk$spoljnafiksnazaluzina") {
    return draftel_codecs_pack_terkk$spoljnafiksnazaluzina.default_preset_state();
  }
  // Abecedni deo redosleda Ispod SFZ a iznad postolja
  if (_draftelschemakey === "terkk$kadica") {
    return draftel_codecs_pack_terkk$kadica.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_klizac") {
    return draftel_codecs_pack_terkk$_bundle_klizac.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_klizacramamraztermostata") {
    // OBSOLETE
    // PPGRUPA RMT - VAZNO NE KORISTI SE OVAJ klizacramamraztermostata jer je on sada u sastavu PPGRUPA RMT
    return draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_kucisteelektrogrejaca") {
    return draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_npr") {
    return draftel_codecs_pack_terkk$_bundle_npr.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_nrr") {
    return draftel_codecs_pack_terkk$_bundle_nrr.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_nosacventilatora") {
    return draftel_codecs_pack_terkk$_bundle_nosacventilatora.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_parniovlazivac") {
    return draftel_codecs_pack_terkk$_bundle_parniovlazivac.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_ppd") {
    return draftel_codecs_pack_terkk$_bundle_ppd.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_ppv") {
    return draftel_codecs_pack_terkk$_bundle_ppv.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_prigusivacbuke") {
    return draftel_codecs_pack_terkk$_bundle_prigusivacbuke.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_protivkisnazaluzina") {
    return draftel_codecs_pack_terkk$_bundle_protivkisnazaluzina.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_ramfiltera") {
    return draftel_codecs_pack_terkk$_bundle_ramfiltera.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_ramfilteranauklizavanje") {
    return draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_rammraztermostata") {
    return draftel_codecs_pack_terkk$_bundle_rammraztermostata.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_usmerivacvazduha") {
    return draftel_codecs_pack_terkk$_bundle_usmerivacvazduha.default_preset_state();
  }
  // Zadnji deo redosleda pocinje od postolja.
  if (_draftelschemakey === "terkk$_bundle_postolje") {
    return draftel_codecs_pack_terkk$_bundle_postolje.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_krov") {
    return draftel_codecs_pack_terkk$_bundle_krov.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_paletapakovanja") {
    return draftel_codecs_pack_terkk$_bundle_paletapakovanja.default_preset_state();
  }
  //
  if (_draftelschemakey === "terkk$_bundle_limcustom") {
    return draftel_codecs_pack_terkk$_bundle_limcustom.default_preset_state();
  }
  if (_draftelschemakey === "terkk$_bundle_profilcustom") {
    return draftel_codecs_pack_terkk$_bundle_profilcustom.default_preset_state();
  }
  if (_draftelschemakey === "terkk$materijalcustom") {
    return draftel_codecs_pack_terkk$materijalcustom.default_preset_state();
  }

  // experimental
  /*
  if (_draftelschemakey === "zzkitc$kitc") {
    return draftel_codecs_pack_zzkitc$kitc.default_preset_state();
  }
  if (_draftelschemakey === "zzkitc$kitc$element") {
    return draftel_codecs_pack_zzkitc$kitc$element.default_preset_state();
  }
  if (_draftelschemakey === "zzkitc$kitc$wbp") {
    return draftel_codecs_pack_zzkitc$kitc$wbp.default_preset_state();
  }
  */

  // FIX ZA NOVE
  if (_draftelschemakey === "terkk$_bundle_novo") {
    return { _subform_arr: [] };
  }

  return false;
};


// OLD
const OLD_draftel_codecs_datarender_virbom_from_single_draftel = (draftel) => {
  let virbom = false;
  // nivo 1 klimakomora
  if (draftel._draftelschemakey === 'terkk$klimakomora') {
    // const virbom = _datarender_virbom_from_single_virtel(draftel);
    const virbom = draftel_codecs_pack_terkk$klimakomora.drafel_to_virbom(draftel);
    return virbom;
  }
  // nivo 2 modul
  if (draftel._draftelschemakey === 'terkk$modul') {
    const virbom = draftel_codecs_pack_terkk$modul.drafel_to_virbom(draftel);
    return virbom;
  }
  //
  // nivo 3 pp3
  //
  if (draftel._draftelschemakey === 'terkk$_bundle_panel') {
    const virbom = draftel_codecs_pack_terkk$_bundle_panel.bundleDrafel_to_virbom(draftel);
    return virbom;
  }
  if (draftel._draftelschemakey === 'terkk$demper') {
    const virbom = draftel_codecs_pack_terkk$demper.drafel_to_virbom(draftel);
    return virbom;
  }
  if (draftel._draftelschemakey === 'terkk$elasticnaveza') {
    const virbom = draftel_codecs_pack_terkk$elasticnaveza.drafel_to_virbom(draftel);
    return virbom;
  }
  if (draftel._draftelschemakey === 'terkk$_bundle_eliminatorkapi') {
    const virbom = draftel_codecs_pack_terkk$_bundle_eliminatorkapi.bundleDrafel_to_virbom(draftel);
    return virbom;
  }
  if (draftel._draftelschemakey === 'terkk$spoljnafiksnazaluzina') {
    const virbom = draftel_codecs_pack_terkk$spoljnafiksnazaluzina.drafel_to_virbom(draftel);
    return virbom;
  }
  // Abecedni deo redosleda Ispod SFZ a iznad postolja
  if (draftel._draftelschemakey === 'terkk$kadica') {
    const virbom = draftel_codecs_pack_terkk$kadica.drafel_to_virbom(draftel);
    return virbom;
  }
  if (draftel._draftelschemakey === 'terkk$_bundle_klizac') {
    // NE KORISTI SE jer je ovaj draftel prebacen na protobomp koncept
    // const virbom = draftel_codecs_pack_terkk$_bundle_klizac.bundleDrafel_to_virbom(draftel);
    return virbom;
  }
  /*
  if (draftel._draftelschemakey === 'terkk$kucisteelektrogrejaca') {
    const virbom = draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.drafel_to_virbom(draftel);
    return virbom;
  }
  */
  /*
  if (draftel._draftelschemakey === 'terkk$ppd') {
    const virbom = draftel_codecs_pack_terkk$_bundle_ppd.drafel_to_virbom(draftel);
    return virbom;
  }
  */
  if (draftel._draftelschemakey === 'terkk$_bundle_ppv') {
    const virbom = draftel_codecs_pack_terkk$_bundle_ppv.bundleDrafel_to_virbom(draftel);
    return virbom;
  }
  if (draftel._draftelschemakey === 'terkk$_bundle_ramfilteranauklizavanje') {
    const virbom = draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.bundleDrafel_to_virbom(draftel);
    return virbom;
  }



  // Zadnji deo redosleda pocinje od postolja.
  if (draftel._draftelschemakey === 'terkk$_bundle_postolje') {
    const virbom = draftel_codecs_pack_terkk$_bundle_postolje.bundleDrafel_to_virbom(draftel);
    return virbom;
  }
  if (draftel._draftelschemakey === 'terkk$_bundle_krov') {
    // NOVO
    const virbom = draftel_codecs_pack_terkk$_bundle_krov.bundleDrafel_to_virbom(draftel);
    return virbom;
  }
  /*
  if (draftel._draftelschemakey === 'terkk$paletapakovanja') {
    // NOVO
    const virbom = draftel_codecs_pack_terkk$paletapakovanja.drafel_to_virbom(draftel);
    return virbom;
  }
  */
  if (draftel._draftelschemakey === 'terkk$_bundle_limcustom') {
    const virbom = draftel_codecs_pack_terkk$_bundle_limcustom.bundleDrafel_to_virbom(draftel);
    return virbom;
  }
  if (draftel._draftelschemakey === 'terkk$_bundle_profilcustom') {
    const virbom = draftel_codecs_pack_terkk$_bundle_profilcustom.bundleDrafel_to_virbom(draftel);
    return virbom;
  }
  if (draftel._draftelschemakey === 'terkk$materijalcustom') {
    const virbom = draftel_codecs_pack_terkk$materijalcustom.drafel_to_virbom(draftel);
    return virbom;
  }

  // experimental
  /*
  if (draftel._draftelschemakey === 'zzkitc$kitc') {
    const virbom = draftel_codecs_pack_zzkitc$kitc.drafel_to_virbom(draftel); //
    return virbom;
  }
  if (draftel._draftelschemakey === 'zzkitc$kitc$element') {
    const virbom = draftel_codecs_pack_zzkitc$kitc$element.bundleDrafel_to_virbom(draftel); //
    return virbom;
  }
  */
  //
  return null;
  //
  return _draftel_codecs_multiadapter().datarender_virbom_from_single_draftel(draftel);
};


// CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION
export const _terkk_convert_virbom_seq_to_draftel_arr_and_smartbom = (virbom_seq, _generate_fresh_subkey, _generateFreshTempkey) => {
  console.log('----- _convert_virbom_seq_TO_DRAFTEL_ARR()');
  // NAPRAVITI OVU FUNKCIJU da sortira sve onim redom kojim ide u virbom_seq
  // klimakomora pa modul pa redom njegovi delovi... pa seldeci modul itd...
  //
  // STEP u ovom slučaju smartbom i virbom ne postoje i tek sada će biti kreirani, kreiramo novi prazan smartbom najnovija verzija sa najnovijim cparams default.
  const default_smartbom_cparams = _getTerkkCparamsDefaultFromLib();
  let smartbom = _smartbom_manipulator_init_make_smartbom(terUtils_make_smartbom_manifest_terkk_v1_0(), default_smartbom_cparams);
  // let smartbom = terUtils_make_smartbom_blank_latest();
  //
  let _kk_za_kasnije = [];
  let _mm_za_kasnije = [];
  let _arr_profilpregradniunc_za_kasnije = [];
  let _panel_za_kasnije = [];
  let _demper_za_kasnije = [];
  let _elk_za_kasnije = [];
  let _elasticnaveza_za_kasnije = [];
  let _sfz_za_kasnije = [];
  let _kadica_za_kasnije = [];
  let _postoljeprofil_za_kasnije = [];
  let _krovsegment_za_kasnije = [];
  let _materijalcustom_za_kasnije = [];
  let _profilcustom_za_kasnije = [];
  let _limcustom_za_kasnije = [];
  let _draftel_arr = [];
  virbom_seq.forEach((virtel) => {
    console.log(virtel.virtelschemakey);
    const sema = virtel_schema_smart_get(virtel.virtelschemakey);
    if (sema && sema.program && sema.program.use_autocreate === true) {
      // ne upisujemo nigde ovo, bice izracunato i kreirano automatski
    } else {
      if (virtel.virtelschemakey === 'terkk$klimakomora') {
        _kk_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$modul') {
        _mm_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$modul$profilpregradni') {
        console.log('terkk$modul$profilpregradni');
        console.log(virtel);
        _arr_profilpregradniunc_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$panel') { // TODO proveriti da li zbog dva razlicita panela pravi vise bundlea i da li treba dodati virtelclass
        _panel_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$demper') {
        _demper_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$eliminatorkapi') {
        _elk_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$elasticnaveza') {
        _elasticnaveza_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$spoljnafiksnazaluzina') {
        _sfz_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$kadica' && virtel.virtelclass === 'terkk$kadica') {
        _kadica_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$postolje$profil' && (virtel.virtelclass === 'terkk$postolje$profil' || virtel.virtelclass === 'terkk$postolje$profil_niski')) {
        _postoljeprofil_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$krov$child') {
        _krovsegment_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$materijalcustom') {
        _materijalcustom_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$profilcustom') {
        _profilcustom_za_kasnije.push(virtel);
      } else if (virtel.virtelschemakey === 'terkk$limcustom') {
        _limcustom_za_kasnije.push(virtel);
      } else {
        // nema ostalih. u draftel_arr idu samo ovi, a u virbom_seq idu svi sa backenda
      }
    }
  });
  console.log('_elk_za_kasnije', _elk_za_kasnije);
  console.log('_mm_za_kasnije', _mm_za_kasnije);
  console.log('_arr_profilpregradniunc_za_kasnije', _arr_profilpregradniunc_za_kasnije);
  console.log('_kadica_za_kasnije', _kadica_za_kasnije);
  //
  // najpre dodajemo klimakomore da se ne bi desilo da neki modul kasnije nema parent
  _kk_za_kasnije.forEach((virtel_k) => {
    const draftel = draftel_codecs_pack_terkk$klimakomora.virtel_to_draftel(virtel_k);
    _draftel_arr.push(draftel);
    smartbom = _smartbom_manipulator_add_draftel(smartbom, draftel, draftel.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
  });
  //
  // zatim dodajemo modul da se ne bi desilo da neki pp3 deo modeula kasnije nema parent
  _mm_za_kasnije.forEach((virtel_m) => {
    // _mm.push(draftel_codecs_pack_terkk$modul._special_combo_to_bundleDraftel(m, _arr_profilpregradniunc_za_kasnije, _generateFreshTempkey));
    const draftel = draftel_codecs_pack_terkk$modul._special_combo_to_bundleDraftel(virtel_m, _arr_profilpregradniunc_za_kasnije, _generate_fresh_subkey, _generateFreshTempkey);
    _draftel_arr.push(draftel);
    smartbom = _smartbom_manipulator_add_draftel(smartbom, draftel, draftel.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
  });
  //
  // nakon klima komore i modula dodajemo pp3 elemente jer ce sada sigurnoo vec imati svoj parent u smartel_arr
  //
  if (_panel_za_kasnije.length > 0) {
    const panel_bundle_arr = draftel_codecs_pack_terkk$_bundle_panel._virtelArr_to_bundleDraftel(_panel_za_kasnije, _generate_fresh_subkey, _generateFreshTempkey);
    panel_bundle_arr.forEach(bundle_item => {
      // bundle_arr je array draftela koji su bundle. Oni su u nizu jer ih ima vise koji pripadaju razlicitim modulima. Za svaki modul moze da bude po jedan takav.
      // _pp.push(bundle_item);
      _draftel_arr.push(bundle_item);
      smartbom = _smartbom_manipulator_add_draftel(smartbom, bundle_item, bundle_item.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
    });
  }
  //
  if (_demper_za_kasnije.length > 0) {
    _demper_za_kasnije.forEach((p) => {
      const draftel = draftel_codecs_pack_terkk$demper.virtel_to_draftel(p);
      _draftel_arr.push(draftel);
      smartbom = _smartbom_manipulator_add_draftel(smartbom, draftel, draftel.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
    });
  }
  //
  if (_elk_za_kasnije.length > 0) {
    const elk_bundle_arr = draftel_codecs_pack_terkk$_bundle_eliminatorkapi._virtelArr_to_bundleDraftel(_elk_za_kasnije, _generate_fresh_subkey, _generateFreshTempkey);
    elk_bundle_arr.forEach(bundle_item => {
      // bundle_arr je array draftela koji su bundle. Oni su u nizu jer ih ima vise koji pripadaju razlicitim modulima. Za svaki modul moze da bude po jedan takav.
      // _pp.push(bundle_item);
      _draftel_arr.push(bundle_item);
      smartbom = _smartbom_manipulator_add_draftel(smartbom, bundle_item, bundle_item.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
    });
  }
  //
  if (_elasticnaveza_za_kasnije.length > 0) {
    _elasticnaveza_za_kasnije.forEach((p) => {
      const draftel = draftel_codecs_pack_terkk$elasticnaveza.virtel_to_draftel(p);
      _draftel_arr.push(draftel);
      smartbom = _smartbom_manipulator_add_draftel(smartbom, draftel, draftel.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
    });
  }
  //
  if (_sfz_za_kasnije.length > 0) {
    _sfz_za_kasnije.forEach((p) => {
      const draftel = draftel_codecs_pack_terkk$spoljnafiksnazaluzina.virtel_to_draftel(p);
      _draftel_arr.push(draftel);
      smartbom = _smartbom_manipulator_add_draftel(smartbom, draftel, draftel.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
    });
  }
  //
  if (_kadica_za_kasnije.length > 0) {
    _kadica_za_kasnije.forEach((p) => {
      const draftel = draftel_codecs_pack_terkk$kadica.virtel_to_draftel(p);
      _draftel_arr.push(draftel);
      smartbom = _smartbom_manipulator_add_draftel(smartbom, draftel, draftel.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
    });
  }
  //
  if (_postoljeprofil_za_kasnije.length > 0) {
    const postoljeprofil_bundle_arr = draftel_codecs_pack_terkk$_bundle_postolje._virtelArr_to_bundleDraftel(_postoljeprofil_za_kasnije, _generate_fresh_subkey, _generateFreshTempkey);
    postoljeprofil_bundle_arr.forEach(bundle_item => {
      // bundle_arr je array draftela koji su bundle. Oni su u nizu jer ih ima vise koji pripadaju razlicitim modulima. Za svaki modul moze da bude po jedan takav.
      // _pp.push(bundle_item);
      _draftel_arr.push(bundle_item);
      smartbom = _smartbom_manipulator_add_draftel(smartbom, bundle_item, bundle_item.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
    });
  }
  //
  if (_krovsegment_za_kasnije.length > 0) {
    const krovsegment_bundle_arr = draftel_codecs_pack_terkk$_bundle_krov._virtelArr_to_bundleDraftel(_krovsegment_za_kasnije, _generate_fresh_subkey, _generateFreshTempkey);
    krovsegment_bundle_arr.forEach(bundle_item => {
      // bundle_arr je array draftela koji su bundle. Oni su u nizu jer ih ima vise koji pripadaju razlicitim modulima. Za svaki modul moze da bude po jedan takav.
      // _pp.push(bundle_item);
      _draftel_arr.push(bundle_item);
      smartbom = _smartbom_manipulator_add_draftel(smartbom, bundle_item, bundle_item.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
    });
  }
  //
  if (_limcustom_za_kasnije.length > 0) {
    const limcustom_bundle_arr = draftel_codecs_pack_terkk$_bundle_limcustom._virtelArr_to_bundleDraftel(_limcustom_za_kasnije, _generate_fresh_subkey, _generateFreshTempkey);
    limcustom_bundle_arr.forEach(bundle_item => {
      // bundle_arr je array draftela koji su bundle. Oni su u nizu jer ih ima vise koji pripadaju razlicitim modulima. Za svaki modul moze da bude po jedan takav.
      // _pp.push(bundle_item);
      _draftel_arr.push(bundle_item);
      smartbom = _smartbom_manipulator_add_draftel(smartbom, bundle_item, bundle_item.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
    });
  }
  //
  if (_profilcustom_za_kasnije.length > 0) {
    const profilcustom_bundle_arr = draftel_codecs_pack_terkk$_bundle_profilcustom._virtelArr_to_bundleDraftel(_profilcustom_za_kasnije, _generate_fresh_subkey, _generateFreshTempkey);
    profilcustom_bundle_arr.forEach(bundle_item => {
      // bundle_arr je array draftela koji su bundle. Oni su u nizu jer ih ima vise koji pripadaju razlicitim modulima. Za svaki modul moze da bude po jedan takav.
      // _pp.push(bundle_item);
      _draftel_arr.push(bundle_item);
      smartbom = _smartbom_manipulator_add_draftel(smartbom, bundle_item, bundle_item.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
    });
  }
  //
  if (_materijalcustom_za_kasnije.length > 0) {
    _materijalcustom_za_kasnije.forEach((p) => {
      const draftel = draftel_codecs_pack_terkk$materijalcustom.virtel_to_draftel(p);
      _draftel_arr.push(draftel);
      smartbom = _smartbom_manipulator_add_draftel(smartbom, draftel, draftel.parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
    });
  }
  //
  //
  // return _draftel_arr;
  console.log('++++++++++ _terkk_convert_virbom_seq_to_draftel_arr_and_smartbom RETURNING SMARTBOM');
  // console.log(smartbom);
  return {
    _draftel_arr,
    smartbom
  }
};


//
const _novo = () => {


  // KORAK null-uj SVA POLJA NA BAZI DRAFTEL SCHEMA

  // KORAK DEFAULT PRESET
  // pretvara oderedjana polja sa null na default vrednsoti


};

